const chat = {
  placeholder: '输入消息，Enter 发送，Shift+Enter 换行',
  send: '发送',
  empty: '暂无消息，发一条打个招呼吧',
  idle: '选择左侧会话开始聊天',
  emoji: '表情',
  image: '图片',
  file: '附件',
  script: '话术',
  hint_enter: 'Enter 发送，Shift + Enter 换行',
  hint_mod: 'Ctrl + Enter 发送，Enter 换行',
  hint_ctrl_newline: 'Enter 发送，Ctrl + Enter 换行',
  online: '在线',
  no_earlier: '没有更早的消息了',
  new_messages: '{{count}} 条新消息',
  sent: '已发送',
  delivered: '已送达',
  read: '已读',
  sending: '发送中',
  send_failed_retry: '发送失败，点击重发',
  send_failed: '发送失败',
  view: '查看',
  today: '今天',
  yesterday: '昨天',
  same_year: '{{month}}月{{day}}日',
  full: '{{year}}年{{month}}月{{day}}日',
  me: '我',
  me_prefix: '我：',
  self_initial: '我'
};

export default chat;
